import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IDatasource, Query } from 'utility-ts-orm';
import { Resource } from '../builders/resource_builder';
import { ResourceCategory } from '../builders/resource_category_builder';
import { IResourceDetail, ResourceDetailBuilder } from '../builders/resource_detail_builder';
import { ResourceInfo } from '../builders/resource_info_builder';
import { ResourceLocation } from '../builders/resource_location_builder';

export class ResourceListQuery implements IQuery {
  private _result: IResourceDetail[];

  constructor(
    private ngResourceDatastore: IDatasource<Resource>,
    private ngResourceInfoDatastore: IDatasource<ResourceInfo>,
    private ngResourceLocationDatastore: IDatasource<ResourceLocation>,
    private ngResourceCategoryDatastore: IDatasource<ResourceCategory>,
    private ngResourceDetailBuilder: ResourceDetailBuilder
  ) {
    Query.registerQuery(
      this,
      this.ngResourceDatastore,
      this.ngResourceInfoDatastore,
      this.ngResourceLocationDatastore,
      this.ngResourceCategoryDatastore
    );
  }

  run(): this {
    const resources: Resource[] = this.ngResourceDatastore.values();
    this._result = _4.map(resources, (resource: Resource) =>
      this.ngResourceDetailBuilder.buildResourceDetail(resource)
    );

    return this;
  }

  get result() {
    return this._result;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/queries/resource_list_query.ts